export const PRECISION_NUMBER_NINE_ZEROES = 1000000000
export const PRECISION_NUMBER_EIGHT_ZEROES = 100000000
export const PRECISION_NUMBER_SIX_ZEROES = 1000000

export const INTERVAL_PRICE_CUSHION = {
  quotes5mNogaps: 50,
  quotes15mNogaps: 50,
  quotes1hNogaps: 100,
  quotes1dNogaps: 400,
  quotes1w: 400,
  quotes1mo: 400,
  quotesTotal: 400,
}

export const ROCKET_LOADER = 'rocket'
export const WERT_IO_LOADER = 'wert-loader'
